<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="migrate" label="是否地址迁移">
                        <check-tag-group
                            style="display: inline-block"
                            v-model="info.migrate"
                            color="primary"
                        >
                            <check-tag
                                v-for="item in migrateList"
                                :name="item.id"
                                :key="item.id"
                            >
                                {{ item.text }}
                            </check-tag>
                        </check-tag-group>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="3"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import Dict from "_u/dict";
import { deepCopy, ymd } from "_u/helper";

import { billAddrMigrate } from "@/api/bill";

export default {
    name: "BillAddrMigrateForm",

    props: {
        contractId: {
            type: [String, Number],
            default: "",
        },
        migrate: {
            type: [String, Number],
            default: "",
        },
    },

    components: {},

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                contractId: this.contractId, // 合同编号
                migrate: [this.migrate], // 是否迁移
                remark: "",
            },
            migrateList: [
                { id: 1, text: "是" },
                { id: 0, text: "否" },
            ],
        };
    },
    computed: {
        ruleValidate() {
            return {};
        },
    },

    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        }
        this.$modal.updateBtns(btns);

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = deepCopy(this.info);
                    formData.migrate = formData.migrate[0];
                    return billAddrMigrate(formData);
                })
                .then((res) => {
                    this.$Message.success(this.$t("tips.update.success"));
                })
                .catch((err) => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    },
};
</script>
<style lang="less" scoped></style>
